export default {
    name: 'nama',
    tel: 'telepon',
    save: 'menyimpan',
    confirm: 'konfirmasi',
    cancel: 'membatalkan',
    delete: 'Menghapus',
    complete: 'membawa',
    loading: 'beban...',
    telEmpty: 'Silakan isi telepon',
    nameEmpty: 'Tolong isi nama anda',
    nameInvalid: 'Harap masukkan nama yang benar',
    confirmDelete: 'Anda yakin ingin menghapusnya',
    telInvalid: 'Harap masukkan nomor telepon yang benar',
    vanCalendar: {
        end: 'Akhir',
        start: 'Mulailah',
        title: 'Pemilihan tanggal',
        confirm: 'menentukan',
        startEnd: 'mulai akhir',
        weekdays: ['hari', 'Satu', 'dua', 'tiga', 'empat', 'Fives', 'enam'],
    },
    vanCascader: {
        select: 'tolong pilih',
    },
    vanContactCard: {
        addText: 'tambah kontak',
    },
    vanContactList: {
        addText: 'Kontak baru',
    },
    vanPagination: {
        prev: 'Halaman sebelumnya',
        next: 'Halaman selanjutnya',
    },
    vanPullRefresh: {
        pulling: 'Tarik ke bawah untuk menyegarkan...',
        loosing: 'Lepaskan untuk menyegarkan...',
    },
    vanSubmitBar: {
        label: 'total：',
    },
    vanCoupon: {
        unlimited: 'Tidak ada ambang batas penggunaan',
    },
    vanCouponCell: {
        title: 'kupon',
        tips: 'Tidak tersedia',
    },
    vanCouponList: {
        empty: 'Tidak ada kupon',
        exchange: 'bertukar',
        close: 'Tidak ada kupon',
        enable: 'Tersedia',
        disabled: 'tidak tersedia',
        placeholder: 'Harap masukkan kode kupon',
    },
    vanAddressEdit: {
        area: 'daerah',
        postal: 'Kode Pos',
        areaEmpty: 'pilih wilayahnya',
        addressEmpty: 'Harap isi alamat rinci',
        postalEmpty: 'Format kode pos salah',
        defaultAddress: 'Tetapkan sebagai alamat pengiriman default',
        telPlaceholder: 'Nomor ponsel penerima barang',
        namePlaceholder: 'Nama penerima barang',
        areaPlaceholder: 'Pilih provinsi / kota / kabupaten',
    },
    vanAddressEditDetail: {
        label: 'Alamat',
        placeholder: 'Nomor rumah jalan, nomor kamar lantai dan informasi lainnya',
    },
    vanAddressList: {
        add: 'Tambahkan alamat',
    },
};